import React from 'react';
import PropTypes from 'prop-types';

const HorizontalHeader = ({ h1, h2, h3 }) => {
  return (
    <h1 className="w-full text-center">
      {h1 && (
        <span className="block
          text-[1rem] lg:text-[28px] leading-[3.125rem] lg:leading-[3.875rem]
          text-white font-bold mb-2 break-words
        ">
          {h1}
        </span>
      )}
      {h2 && (
        <span className="block font-bold text-white text-[32px] lg:text-[60px]
                      leading-normal lg:leading-normal mb-2">
          {h2}
        </span>
      )}
      {h3 && (
        <span className="block font-semibold text-white text-[1.2rem]
                      lg:text-[1.375rem] mt-1 leading-[1.875rem] mb-2 lg:mb-10">
          {h3}
        </span>
      )}
    </h1>
  );
};

HorizontalHeader.propTypes = {
  h1: PropTypes.string,
  h2: PropTypes.string,
  h3: PropTypes.string,
};

export default HorizontalHeader;
